export const getAttemptId = (state) => state.rootReducer.myCourse.attemptId;
export const getCourseId = (state) => state.rootReducer.loginDetails.courseId;
export const getDeepLinkCourseId = (state) =>
	state.rootReducer.myCourse.courseId;
export const getElementId = (state) => state.rootReducer.myCourse.elementId;
export const getSpeechStatus = (state) => state.rootReducer.myCourse.isSpeechOn;
export const getScheduleId = (state) =>
	state.rootReducer.myCourse.taskScheduleId;
export const getSelectedFile = (state) =>
	state.rootReducer.myCourse.selectedFile;
export const getReason = (state) => state.rootReducer.myCourse.cancelReason;
export const getCancelScheduleId = (state) =>
	state.rootReducer.myCourse.cancelScheduleId;
export const getQueryElementId = (state) =>
	state.router.location.query.element_id;
export const getGrade = (state) => state.rootReducer.myCourse.studentGrade;
export const getCourseDetails = (state) =>
	state.rootReducer.myCourse.coursedetails;
